import loadable, {
    DefaultComponent,
    LoadableComponent,
} from '@loadable/component';

const withLoadable = <Props extends {}>(
    loadFn: (props: Props) => Promise<DefaultComponent<Props>>
): LoadableComponent<Props> => loadable<Props>(loadFn);

export default withLoadable;
